module.exports = __webpack_public_path__ + "images/3abf1f671f2fd5fc0e821cf210b4cd50.png";